/* eslint-disable @typescript-eslint/no-floating-promises */
import { Box, Typography } from "@mui/material";
import { Map } from "ol";
import React from "react";
import { useTranslation } from "react-i18next";
import { ArrivalZoneMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type Props = {
  map: Map;
} & (ClickProps | HoverProps);

type ClickProps = {
  clickData: ArrivalZoneMapItem;
  hoverData?: ArrivalZoneMapItem;
};

type HoverProps = {
  hoverData: ArrivalZoneMapItem;
  clickData?: ArrivalZoneMapItem;
};

export const ArrivalZonePopup = ({
  hoverData,
  clickData,
  map,
}: Props): JSX.Element | null => {
  const { t } = useTranslation("arrival-zones");

  const data = clickData ?? hoverData;

  if (!data) return null;
  const { name, description, active, id } = data;

  return (
    <GenericPopup
      map={map}
      clicked={!!clickData}
      avatarColor={active ? "green" : "red"}
      avatarText={String(id) ?? ""}
      title={`${name ?? ""}`}
      subheader={t(`active-${active}`)}
      contentProps={{
        style: { padding: 0, maxHeight: clickData ? 600 : undefined },
      }}
      content={
        description ? (
          <Box p={2}>
            <Typography variant="body2" align="left" noWrap>
              {`${t("description")}: ${description}`}
            </Typography>
          </Box>
        ) : undefined
      }
    />
  );
};
